import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { getBreezeStudioUrl } from '../utils/DetailsPageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function McpServerConnectAlert() {
  const {
    name
  } = useDetailsPageContext();
  return /*#__PURE__*/_jsx(Alert, {
    marginBlockEnd: "600",
    type: "info",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.mcpServerConnectAlert.title"
    }),
    children: /*#__PURE__*/_jsxs("ol", {
      children: [/*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.mcpServerConnectAlert.step1"
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "detailsPage.mcpServerConnectAlert.step2_jsx",
          elements: {
            Link
          },
          options: {
            linkProps: {
              href: getBreezeStudioUrl(),
              external: true,
              hideExternalLinkIcon: true
            }
          }
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.mcpServerConnectAlert.step3"
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.mcpServerConnectAlert.step4"
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.mcpServerConnectAlert.step5",
          options: {
            appName: name
          }
        })
      })]
    })
  });
}